<template>
  <div class="page_ blue_">
    <div class="content">
      <p>
        <span style="width:100px;"
          >{{ $t("claimDetails[5]") || "案件状态" }}：</span
        >
        <span
          v-for="(item, index) in status"
          :key="item.value"
          class="status"
          :class="{ blue: statusIndex == index }"
          @click="statusChage(index, item.value)"
        >
          {{ item.text }}
        </span>
      </p>
      <p>
        <span style="width:100px;"
          >{{ $t("claimDetails[6]") || "时间" }}：</span
        >
        <span
          v-for="(item, index) in pointStatusList"
          :key="item.id"
          @click="pointStatusChange(index, item.id)"
          class="status"
          :class="{ blue: timeIndex == index }"
          >{{ item.name }}</span
        >
      </p>
      <!-- <div>
        <span>{{$t('claimDetails[6]')||'时间'}}：</span>
        <a-select style="width: 150px;border: 1px #E7E7E7 solid;border-radius:4px;"
                  default-value=""
                  @change="pointStatusChange">
          <a-select-option v-for="item in pointStatusList"
                           :key="item.id"
                           :value="item.id">{{item.name}}</a-select-option>
        </a-select>
      </div> -->
      <div class="box_list">
        <div class="list" v-if="claimList.length > 0">
          <div class="list_item" v-for="(item, index) in claimList">
            <div class="item_1">
              <div class="flex_">
                <span class="left">{{
                  $t("claimDetails[24]") || "预授权"
                }}</span>
                <span v-if="item.claimsType === '0'" class="no"
                  >{{ $t("claimDetails[1]") || "报案编号："
                  }}{{ item.claimsId }}</span
                >
                <span v-else class="no"
                  >{{ $t("claimDetails[28]") || "授权编号" }}：{{
                    item.approvalCode
                  }}</span
                >
              </div>
              <div class="box_">
                <span class="circle_"> </span>
                <span v-if="item.claimsStatus != '99'">{{
                  item.claimsStatusDesc
                }}</span>
                <span
                  v-if="item.claimsStatus === '99' && item.list.length === 1"
                  >{{ item.list[0].iclaimsStatusDesc }}</span
                >
                <span v-if="item.claimsStatus === '99' && item.list.length > 1"
                  ><span class="iconew"></span>{{ $t("preAuth.tit") }}</span
                >
              </div>
            </div>
            <div class="item_2">
              <span
                >{{ $t("InsuranceInfo[1]") || "保单号" }}/{{
                  $t("claim[6]") || "出险人"
                }}： {{ item.policyNo }} {{ item.insured }}</span
              >
              <span>{{ $t("preAuth.place") }}：{{ item.providerName }}</span>
              <span v-if="item.docrcvdt"
                >{{ $t("claim[13]") || "就诊日期" }}：{{
                  item.docrcvdt ? item.docrcvdt.substring(0, 10) : ""
                }}</span
              >
              <span
                >{{ $t("claimDetails[29]") || "诊断" }}：{{
                  item.diagnosis
                }}</span
              >
            </div>
            <div class="item_3">
              <span style="color: #999999;">{{ item.createDate }}</span>
              <div style="display:flex;">
                <!-- <span class="detail" @click="detail(item)">{{$t('claimDetails[30]')||'预授权详情'}}</span> -->
                <div class="hover_">
                  <img
                    src="../assets/medilinkPC/more.png"
                    alt=""
                    @click="showMore(index, item)"
                  />
                  <div class="cancel" :class="{ flex_: item.popoverVisible }">
                    <span
                      v-if="
                        item.claimsStatus === '10' ||
                          item.claimsStatus === '20' ||
                          item.claimsStatus === '01'
                      "
                      @click="materialSupply(item)"
                      >{{ $t("preAuth.material") }}</span
                    >
                    <span
                      v-if="
                        item.claimsStatus === '10' ||
                          item.claimsStatus === '20' ||
                          item.claimsStatus === '30'
                      "
                      @click="cancel(item)"
                      >{{ $t("claimDetails[3]") || "撤销申请" }}</span
                    >
                    <span
                      v-if="
                        item.claimsStatus === '04' || item.claimsStatus === '03'
                      "
                      @click="goDes(item)"
                      >{{ $t("preAuth.des") }}</span
                    >
                    <span @click="detail(item)">{{
                      $t("claimDetails[30]") || "预授权详情"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="list list_nodata" v-else>
          <img
            class="nodata_"
            src="../assets/medilinkPC/nodata.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="bottom_">
        <a-button
          style="color: #fff;border-radius:2px;"
          type="primary"
          @click="addClaimApply"
          >+{{ $t("claimDetails[7]") || "新增预授权申请" }}</a-button
        >
        <div style="display: flex;align-items: center;">
          <span style="margin-right:10px;"
            >{{ $t("claimDetails[21]") || "共" }}{{ pagination.totalPage
            }}{{ $t("claimDetails[22]") || "页" }}</span
          >
          <a-pagination
            show-quick-jumper
            :default-current="1"
            :pageSize="pagination.pageSize"
            :total="pagination.totalNum"
            @change="pageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page_ {
  position: relative;
  background-color: #fff;
  height: auto;
  overflow: hidden;
  padding: 17px 27px 17px 27px;
  border-radius: 10px;
  color: #394155;
  .content {
    position: relative;
    span {
      display: inline-block;
    }
    .status {
      width: 130px;
      display: inline-block;
      text-align: center;
      cursor: pointer;
    }
    .blue {
      color: #2c5acc;
    }
    .box_list {
      min-height: 60vh;
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      // min-height:60vh;
      .list_item {
        width: 32%;
        // height: 230px;
        border-radius: 8px;
        margin-top: 30px;
        margin-right: 2%;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.05);
        border-radius: 10px;
        padding: 25px 30px;
        border: 1px solid transparent;
        &:nth-child(3n + 3) {
          margin-right: 0;
        }
        .item_1 {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          .flex_ {
            display: flex;
            align-items: center;
          }
          .left {
            display: inline-block;
            // width: 43px;
            font-size: 10px;
            // height: 21px;
            // line-height:21px;
            padding: 1px 5px;
            border: 1px #2c5acc solid;
            margin-right: 10px;
            text-align: center;
            color: #2c5acc;
            border-radius: 3px;
          }
          .no {
            font-size: 16px;
            font-weight: bold;
          }
        }
        .item_2 {
          display: flex;
          flex-direction: column;
          margin-top: 10px;
          line-height: 24px;
        }
        .item_3 {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 23px;
          color: #2c5acc;
          img {
            margin-left: 10px;
            width: 20px;
            height: 20px;
          }

          .cancel {
            position: absolute;
            bottom: 30px;
            right: 0;
            // width: 82px;
            padding: 4px 15px;
            text-align: center;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 10px 10px 10px 10px;
            background-color: #fff;
            z-index: 2;
            display: none;
            flex-direction: column;
            &.flex_ {
              display: flex;
            }
            span {
              height: 30px;
              line-height: 30px;
              cursor: pointer;
              text-align: center;
            }
          }
        }
        &:hover {
          border: 1px solid #2c5acc;
          // .cancel{
          //   display:flex;
          // }
        }
      }
      .nodata_ {
        width: 81px;
        margin-top: 150px;
        height: 91px;
      }
    }
    .list_nodata {
      justify-content: center;
    }
    .bottom_ {
      // position: absolute;
      bottom: 20px;
      display: flex;
      justify-content: space-between;
      // margin-right: 50px;
      margin-top: 20px;
      width: 100%;
    }
  }
}
.box_ {
  display: flex;
  align-items: center;
}
.circle_ {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 4px;
  background-color: #2c5acc;
  margin-right: 3px;
}
</style>

<script>
import api from "@/utils/api";
const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park"
  },
  {
    key: "2",
    name: "Jim Green",
    age: 42,
    address: "London No. 1 Lake Park"
  },
  {
    key: "3",
    name: "Joe Black",
    age: 32,
    address: "Sidney No. 1 Lake Park"
  }
];

export default {
  data() {
    return {
      addVisible: false,
      data,
      columns: [
        {
          title: this.$t("InsuranceInfo[31]"),
          dataIndex: "name"
        },
        {
          title: this.$t("InsuranceInfo[32]"),
          dataIndex: "age"
        },
        {
          title: this.$t("InsuranceInfo[33]"),
          dataIndex: "address"
        }
      ],
      status: [
        // 1 全部 2 已撤销 3 审核中 4 已结案
        {
          value: "",
          text: this.$t("statusText[0]")
        },
        {
          value: "1",
          text: this.$t("statusText[1]")
        },
        {
          value: "2",
          text: this.$t("statusText[2]")
        },
        {
          value: "3",
          text: this.$t("statusText[4]")
        }
      ],
      statusIndex: 0,
      pointStatusList: [
        // 时间状态 //0 全部 1 一年 2 半年 3 三个月
        {
          id: "",
          name: this.$t("statusText[0]")
        },
        {
          id: "12",
          name: this.$t("statusText[5]")
        },
        {
          id: "6",
          name: this.$t("statusText[6]")
        },
        {
          id: "3",
          name: this.$t("statusText[7]")
        }
      ],
      pagination: {
        pageNum: 1,
        pageSize: 9,
        totalNum: 0,
        totalPage: 0
      },
      claimList: [],
      oriClaimList: [],
      query: {
        status: "",
        timeSpan: ""
      },
      popoverVisible: false,
      enflags: false,
      statusOptionsp: [
        {
          value: "39",
          text: "Cancelled "
        },
        {
          value: "10",
          text: "Authorization application submitted"
        },
        {
          value: "20",
          text: "Authorization application submitted"
        },
        {
          value: "30",
          text: "Pre-authorized materials to be reviewed"
        },
        {
          value: "40",
          text: "Material review,file case"
        },
        {
          value: "50",
          text: "Authorized materials failed"
        },
        {
          value: "05",
          text: "Under Reviewing "
        },
        {
          value: "01",
          text: "Additional Information Requested"
        },
        {
          value: "02",
          text: "Apply Approval by Fronting Comp"
        },
        {
          value: "03",
          text: "Adjudication Completed"
        },
        {
          value: "04",
          text: "Review failed"
        },
        {
          value: "12",
          text: "Pending"
        },
        {
          value: "13",
          text: "Canceled"
        }
      ],
      timeIndex: 0
    };
  },
  filters: {
    filterStatusPre: (val, statusOptionsp) => {
      if (!val) {
        return "";
      } else {
        let textCon = "";
        statusOptionsp.map(item => {
          if (item.value == val) {
            textCon = item.text;
          }
        });
        return textCon;
      }
    }
  },
  mounted() {
    this.preLicensingQuery();
    if (this.$i18n.locale === "en-us") {
      this.enflags = true;
    }
  },
  methods: {
    showMore(index, item) {
      // item.popoverVisible = !item.popoverVisible
      this.claimList[index].popoverVisible = !this.claimList[index]
        .popoverVisible;
    },
    cancel(item) {
      let this_ = this;
      this.$confirm({
        title: this.$t("alertPrompt[0]"),
        content: this.$t("alertPrompt[1]"),
        okText: this.$t("alertPrompt[2]"),
        okType: "danger",
        cancelText: this.$t("alertPrompt[3]"),
        onOk() {
          this_.claimCancel(item);
        },
        onCancel() {
          console.log("Cancel");
        }
      });
      this.popoverVisible = false;
    },
    claimCancel(item) {
      let param = {
        iclaimsId: item.claimsId
      };
      api
        .cancelPreApp(param)
        .then(res => res.data)
        .then(data => {
          this.$message.success(data.msg);
          this.preLicensingQuery();
        });
    },
    goDes(item) {
      api
        .getAuthExplain({
          status: item.claimsStatus,
          iclaimsId: item.claimsId,
          claimsType: item.claimsType
        })
        .then(res => {
          if (res.data.code === 200) {
            window.location.href = res.data.data.explainUrl;
          }
        });
    },
    detail(item) {
      if (item.claimsType == "0") {
        window.preDetail = item.list;
        this.$router.push({
          name: "PreAuthDetail",
          query: {
            iclaimsId: item.claimsId,
            claimsType: item.claimsType
          }
        });
      } else {
        this.$router.push({
          name: "PreDetail",
          query: { claimsId: item.claimsId, claimsType: item.claimsType }
        });
      }
    },
    addClaimApply() {
      this.$router.push({ name: "PreAuthApply" });
    },
    preLicensingQuery() {
      api
        .preLicensingQuery(this.query)
        .then(res => res.data)
        .then(data => {
          this.pagination.totalNum = data.data.length;
          // 总页数=(总页数+页大小-1)/页大小
          this.pagination.totalPage = parseInt(
            (this.pagination.totalNum + this.pagination.pageSize - 1) /
              this.pagination.pageSize
          );
          console.log(this.pagination);
          this.oriClaimList = data.data;
          let list = JSON.parse(JSON.stringify(this.oriClaimList));
          list.forEach(item => {
            item.popoverVisible = false;
          });
          this.claimList = list.splice(0, 9);
        });
    },
    pageChange(pageNum, pageSize) {
      this.pagination.pageNum = pageNum;
      this.toPage();
    },
    toPage() {
      this.claimList = JSON.parse(JSON.stringify(this.oriClaimList));
      let page = (this.pagination.pageNum - 1) * 9;
      this.claimList = this.claimList.splice(page, this.pagination.pageSize);
    },
    pointStatusChange(index, value) {
      this.timeIndex = index;
      this.query.timeSpan = value;
      this.preLicensingQuery();
      console.log(value);
    },
    statusChage(index, value) {
      this.statusIndex = index;
      this.query.status = value;
      console.log(this.query, "this.query");
      this.preLicensingQuery();
    },
    callback(key) {
      console.log(key);
    },
    addCard() {
      this.addVisible = true;
    },
    materialSupply(item) {
      let storageItem = {
        claimsId: item.claimsId,
        claimsStatusDesc: item.claimsStatusDesc,
        claimsStatus: item.claimsStatus,
        iclaimsId: item.claimsId,
        claimsType: item.claimsType
      };
      localStorage.setItem("supplementDetailPre", JSON.stringify(storageItem));
      this.$router.push({
        name: "PreAuthSupplementDetail"
      });
    }
  }
};
</script>
